function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,5h4v20h-4V5ZM0,13h30v4H0v-4Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M5.797,6.954c.467.061.939.061,1.406,0-.271,1.351-.271,2.741,0,4.092-.467-.061-.939-.061-1.406,0,.271-1.351.271-2.741,0-4.092Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M8.546,8.297c-.061.467-.061.939,0,1.406-1.351-.271-2.741-.271-4.092,0,.061-.467.061-.939,0-1.406,1.351.271,2.741.271,4.092,0Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M22.797,6.954c.467.061.939.061,1.406,0-.271,1.351-.271,2.741,0,4.092-.467-.061-.939-.061-1.406,0,.271-1.351.271-2.741,0-4.092Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M25.546,8.297c-.061.467-.061.939,0,1.406-1.351-.271-2.741-.271-4.092,0,.061-.467.061-.939,0-1.406,1.351.271,2.741.271,4.092,0Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M5.797,18.954c.467.061.939.061,1.406,0-.271,1.351-.271,2.741,0,4.092-.467-.061-.939-.061-1.406,0,.271-1.351.271-2.741,0-4.092Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M8.546,20.297c-.061.467-.061.939,0,1.406-1.351-.271-2.741-.271-4.092,0,.061-.467.061-.939,0-1.406,1.351.271,2.741.271,4.092,0Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M22.797,18.954c.467.061.939.061,1.406,0-.271,1.351-.271,2.741,0,4.092-.467-.061-.939-.061-1.406,0,.271-1.351.271-2.741,0-4.092Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M25.546,20.297c-.061.467-.061.939,0,1.406-1.351-.271-2.741-.271-4.092,0,.061-.467.061-.939,0-1.406,1.351.271,2.741.271,4.092,0Z",
    style: {
      fill: "red"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/GE.472eec8e8d2328f9059e2d5334cb2866.svg";
export { ForwardRef as ReactComponent };